export default __webpack_public_path__ + "static/media/hash-large.e1d4e41b.svg";